export const entityTabs = [
  'stocks',
  'etfs',
  'indexes',
  'fx',
  'commodities',
  'govBonds',
];
